import React from "react";

interface SearchLoaderProps {
  className?: string;
  show?: boolean;
}
export const SearchLoader: React.FC<SearchLoaderProps> = ({
  className = "",
  show = false,
}) => {
  return (
    <div
      className={`relative w-full h-1 bg-secondary rounded-full overflow-hidden ${className} ${show ? "" : "invisible"}`}
    >
      <div
        className={`absolute inset-0 h-full bg-primary opacity-75 rounded-full ${show ? "animate-train" : ""}`}
      ></div>
    </div>
  );
};
